import {createTheme, responsiveFontSizes} from "@mui/material";

export const edenredTheme = responsiveFontSizes(createTheme(
    {
        typography: {
            fontFamily: ['Edenred', 'sans-serif'].join(',')
        },
        palette: {
            background:{
              default:'#fff'
            },
            primary: {
                main:'#EF4231',
                contrastText:'#fff'
            },
            secondary: {
                main: '#000'
            }
        }
    }
))
